// IterationTypeComp.jsx
import {
  Box,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import RuleItem from "./RuleItem";

const IterationTypeComp = ({
  control,
  register,
  schema,
  rule,
  path,
  depth,
}) => {
  return (
    <Box
      mt={4}
      p={3}
      bg="yellow.50"
      borderRadius="md"
      border="1px solid"
      borderColor="yellow.200"
    >
      <Text fontWeight="medium" color="yellow.700" mb={2}>
        🔁 Iteration
      </Text>

      <FormControl>
        <FormLabel>Repeatable ID</FormLabel>
        <Controller
          control={control}
          name={`${path}.REPEATABLE_ID`}
          render={({ field }) => (
            <Input
              borderRadius="md"
              borderColor="gray.300"
              bg="white"
              {...field}
              w="50%"
            />
          )}
        />
      </FormControl>

      <Box mt={3} pl={4} borderLeft="3px solid" borderColor="yellow.200">
        <Heading size="xs" mb={2} color="yellow.700">
          Nested Rules
        </Heading>

        <Stack spacing={3}>
          {rule.RULES?.map((nestedRule, idx) => (
            <RuleItem
              key={`${rule.ID}_rule_${idx}`}
              control={control}
              register={register}
              schema={schema}
              rule={nestedRule}
              path={`${path}.RULES.${idx}`}
              remove={() => {
                const updated = [...rule.RULES];
                updated.splice(idx, 1);
                control._updateDefaultValues();
              }}
              depth={depth + 1}
              isStep={true}
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default IterationTypeComp;
